/**
 * What a finished screenshot upload amounts to for the participant.
 *
 * Every terminal state of a reading maps to one of these, so the step can never
 * reach a state it has nothing to say about.
 */
export enum EvidenceOutcomeKind {
  /** Nothing has been uploaded yet, or a reading is still running. */
  None = "none",
  /** A distance was read and may fill the form in. */
  Reading = "reading",
  /** The picture was read and turned down, for reasons we can name. */
  Refused = "refused",
  /** No distance came back, whether the reading broke or the upload never landed. */
  Unreadable = "unreadable",
}
